export enum SpecialWeapon {
  BatLeth,
  MekLeth,
}
